import React from "react";
import { useLocation } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import SUCCESS from "../assets/images/check-circle.svg"
import FAIL from "../assets/images/xmark-circle.svg"
import LOADING from "../assets/images/refresh-double.svg"
import WARNING from "../assets/images/warning-circle.svg"

const PlaidFallbackModal = ({ onClose, variant = 'success', message, secondaryMessage, onTryAgain }) => {
  const location = useLocation();
  const hideManualEntry = ['/dashboard', '/confirm-payment', '/profile'].includes(location.pathname);

  let imageSrc, altText;
  if (variant === 'success') {
    imageSrc = SUCCESS;
    altText = "Success";
  } else if (variant === 'info') {
    imageSrc = LOADING;
    altText = "Loading";
  } else if (variant === 'warning') {
    imageSrc = WARNING;
    altText = "Warning";
  } else {
    imageSrc = FAIL;
    altText = "Fail";
  }

  const defaultMessage = variant === 'success' ? "Your accounts are connected!" : "We couldn’t connect your accounts.";

  return (
    <Modal
      className="PlaidFallbackModal customMiniPopup"
      show={true} // Always show modal when rendered
      onHide={onClose} // Handle closing modal
      aria-labelledby="PlaidFallbackModal"
      backdrop="static"
      keyboard={false}
      centered
    >
      <div className="modal-body">
        <div className="text-center">
          <img className={variant} src={imageSrc} alt={altText} width="64" height="64" />
          <h4 className="mt-3 mb-1 text-center f-600">{message || defaultMessage}</h4>
          <p className="text-center text-grey mb-0">{secondaryMessage || "We pulled in the details we could. You can add or edit anything manually — estimates are totally fine."}</p>
        </div>
        <div className="text-center mt-4 mb-2">
          {/* Show this button in success variant only */}
          {variant === 'success' && (
            <button className="as-btn-primary px-4" onClick={onClose}>
              Continue →
            </button>
          )}

          {/* Show these buttons in Warning & Fail variant only */}
          {(variant === 'warning' || variant === 'error') && (
            <>
              <div className="text-center mt-4 mb-2 d-flex justify-content-center gap-10">
                <button className="as-btn-primary px-5" onClick={() => { onClose(); onTryAgain(); }}>
                  <i class="fa fa-repeat mr-2" aria-hidden="true"></i>
                  Try Again
                </button>
                {!hideManualEntry && (
                  <button onClick={onClose} className="as-btn-primary px-3">
                    Enter Information Manually
                  </button>
                )}
              </div>
              <div>
                <u onClick={onClose}>Skip for Now</u>
              </div>
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default PlaidFallbackModal;
